import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : {};
  const isAdmin = user.role === 'ADMIN';

  const menuItems = [
    { path: '/', altPath: '/home', label: 'Home', icon: '\uD83C\uDFE0', showAlways: true },
    { path: '/setup-agent', label: 'Setup Agent', icon: '\uD83D\uDC64', adminOnly: true },
    { path: '/setup-queue', label: 'Setup Queue', icon: '\uD83D\uDCCB', adminOnly: true },
    { path: '/setup-quick-connect', label: 'Setup Quick Connect', icon: '\u26A1', adminOnly: true },
    { path: '/setup-routing-profile', label: 'Setup Routing Profile', icon: '\uD83E\uDDED', adminOnly: true },
    { path: '/setup-security-profile', label: 'Setup Security Profile', icon: '\uD83D\uDEE1\uFE0F', adminOnly: true },
    { path: '/setup-user-hierarchy-group', label: 'Setup User Hierarchy Group', icon: '\uD83C\uDFD7\uFE0F', adminOnly: true },
    { path: '/setup-send-notification', label: 'Setup Send Notification', icon: '\uD83D\uDD14', adminOnly: true },
    { path: '/setup-program-data', label: 'Setup Colleague Data', icon: '\uD83D\uDDC4\uFE0F', adminOnly: true },
  ];

  const visibleItems = menuItems.filter(item => item.showAlways || (item.adminOnly && isAdmin));

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          {visibleItems.map((item) => (
            <li key={item.path} className="sidebar-menu-item">
              <Link
                to={item.path}
                className={'sidebar-link' +
                  (location.pathname === item.path || location.pathname === item.altPath ? ' active' : '')}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;